import {IReg, IRegPointer, IUiEnv, REG} from "/@lib@/commons/registry.js";
import {ISecurityCtxPointer} from "/@lib@/commons/security.js";
import {CoreUniverse, IBasicUniversePointer, ICoreUniverseEnv, IWsExecFrame, OCoreUniverseConfig} from "/@lib@/core/universe.js";
import {configWspSrv, OWspFeatures, OWspSrvConfig, WspSrv} from "/@lib@/wsp/wsp.js";
import {configPackSrv, IPacksInUniverse, OPacksInUniverseConfig, PackSrv} from "/@lib@/wsp/pack.js";
import {configExecutorSrv, ExecutorSrv, IExecutorInUniverse, OExecutorInUniverseConfig} from "/@lib@/core/executor.js";
import {AreaAsync} from "/@lib@/commons/areas.js";
import {IO} from "/@lib@/commons/io/io.js";


export interface OChainUniverseConfig extends OCoreUniverseConfig, OPacksInUniverseConfig, OExecutorInUniverseConfig {
	wsps?: OWspSrvConfig
	backEnd: 'fs' | 'odb'
	wspFeatures?: OWspFeatures
	/** true si le serveur a pour vocation à être exploité localement (ex : scChain-desktop) */
	local?: boolean
	/** true si la fonction drv est active dans l'univers */
	drv?: boolean
	/** true si la fonction drv destinée à la traduction est active dans l'univers */
	drvL10n?: boolean
	/** true si la fonction drf est active dans l'univers */
	drf?: boolean
}

export class ChainUniverse extends CoreUniverse implements IPacksInUniverse, IExecutorInUniverse {

	config: OChainUniverseConfig;

	reg: IReg<IChainEnv>;

	wspServer: WspSrv;

	packServer: PackSrv;

	executor: ExecutorSrv;

	wsFrames: {
		ws: IWsExecFrame
	};

	constructor(config: OChainUniverseConfig) {
		super(config);
		const reg = this.reg;
		REG.reg.addToList("rolesExplorer:tabs", config.id || "chain", 1, new AreaAsync<IRegPointer<ICoreUniverseEnv & IUiEnv>>()
			.setLabel(config.name || "Entrepôt")
			.setVisible((ctx) => {return reg.hasPerm("exportConfig.roles")})
			.requireLib(IO.asEndPoint("/@back@/wsp/views/wspRolesExplorer.js"))
			.setBodyBuilder(function (this:AreaAsync, ctx){
				const MOD: typeof import("/@back@/wsp/views/wspRolesExplorer.js") = this._modules[0];
				return new MOD.WspRolesExplorerTab().initialize({
					reg
				})
			}));
	}

	buildConfig(config: OChainUniverseConfig) {
		if (!config.wsFrames) config.wsFrames = {};
		if (!config.wsFrames.ws) config.wsFrames.ws = {};
		super.buildConfig(config);
		config.wsps = configWspSrv(config.httpFrames.web.execFrameUrl, config.wsps);
		if (config.packs !== null) config.packs = configPackSrv(config.httpFrames.web.execFrameUrl, config.packs);
		if (config.executor !== null) config.executor = configExecutorSrv(config.httpFrames.web.execFrameUrl, config.executor);
	}

	buildUniverse(config: OChainUniverseConfig) {
		super.buildUniverse(config);
		this.wspServer = new WspSrv(this, config.wsps);
		if (config.packs !== null) this.packServer = new PackSrv(this, config.packs);
		if (config.executor !== null) this.executor = new ExecutorSrv(config.executor);
	}

	/** Evalue les wspFeatures */
	getWspFeatureStatus(feat: 'publicWsp' | 'extIt' | 'airIt'): "alwaysTrue" | "alwaysFalse" | "trueByDefault" | "falseByDefault" | "deprecated" | undefined {
		return this.config.wspFeatures ? this.config.wspFeatures[feat] : undefined;
	}

}

interface IChainUniversePointer extends IBasicUniversePointer {
	universe: ChainUniverse
}

/** Environnement de registre attendu pour un contexte d'un univers chain. */
export type IChainEnv = IChainUniversePointer & ISecurityCtxPointer;
